import { render, staticRenderFns } from "./Bdsd.vue?vue&type=template&id=60586e64&scoped=true"
import script from "./Bdsd.vue?vue&type=script&lang=js"
export * from "./Bdsd.vue?vue&type=script&lang=js"
import style0 from "./Bdsd.vue?vue&type=style&index=0&id=60586e64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60586e64",
  null
  
)

export default component.exports